import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Typography from 'material-ui/Typography'

export const ModalHeader = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.header}>
      {children}
    </div>
  )
})

export const ModalContents = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.contents}>
      {children}
    </div>
  )
})

export const ModalFooter = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.footer}>
      <Typography align="right">
        {children}
      </Typography>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/common/modal/index.js